import React, { FunctionComponent, useContext, useEffect } from "react";
import { sendTealiumEvent, useQueryParams, useTranslate } from "../../helpers";
import { withRouter, RouteComponentProps } from "react-router";
import { AppPage } from "../../components";
import { Card, Button } from "@cmsgov/ds-medicare-gov";
import routes from "../../app/routes";
import { AppStore } from "../../app/store";
import { ActionType } from "../../@types";
import { CoverageType } from "../QuestionRoutingPage/types";
import { FormattedHTMLMessage } from "react-intl-phraseapp";
import { createGa4Event, Ga4Event } from "../../helpers/analytics";
import { useFlags } from "launchdarkly-react-client-sdk";

const CoverageWizardOptionsPage: FunctionComponent<RouteComponentProps> = props => {
  useQueryParams(props);
  const t = useTranslate();
  const flags = useFlags();

  const { state, dispatch } = useContext(AppStore.AppContext);

  useEffect(() => {
    createGa4Event({ event_name: Ga4Event.CW_STARTED, state, flags });
  }, []);

  const chooseCoverage = (coverage: CoverageType): void => {
    dispatch({
      type: ActionType.UPDATE_CW_COVERAGE,
      payload: coverage,
    });
    props.history.push(routes.coverageWizard.info);
  };

  return (
    <AppPage
      heading={t("cw.your_options")}
      bannerClassName="CoverageWizardOptionsPage__banner"
      outerClassName="ds-u-md-display--flex ds-u-md-flex-direction--column ds-u-md-align-items--center"
      hideLogin={true}
    >
      <div className="CoverageWizardOptionsPage__container">
        <p>{t("cw.options.two_ways")}</p>
        <p className="ds-u-display--none ds-u-md-display--block">
          {t("cw.options.choose_option")}
        </p>
        <ul className="CoverageWizardOptionsPage__cards" role="list">
          <li role="listitem">
            <Card className="CoverageWizardOptionsPage__card">
              <h2>{t("cw.options.original_medicare")}</h2>
              <ul className="ds-c-list mct-disc-list" role="list">
                <li role="listitem">{t("cw.options.om.part_a_b")}</li>
                <li role="listitem">
                  <FormattedHTMLMessage id="cw.options.om.drug_coverage" />
                </li>
                <li role="listitem">{t("cw.options.om.medigap")}</li>
              </ul>
              <Button
                className="CoverageWizardOptionsPage__omDesktopButton ds-u-display--none ds-u-md-display--block ds-c-button ds-c-button--primary-alt mct-u-width--full ds-u-margin-top--2"
                onClick={(): void => {
                  sendTealiumEvent(
                    "Coverage Wizard - Options",
                    "CTA: Original Medicare"
                  );

                  chooseCoverage(CoverageType.OriginalMedicare);
                }}
              >
                {t("cw.options.original_medicare")}
              </Button>
            </Card>
          </li>
          <li role="listitem">
            <Card className="CoverageWizardOptionsPage__card">
              <h2>{t("cw.options.mapd")}</h2>
              <ul className="ds-c-list mct-disc-list" role="list">
                <li role="listitem">{t("cw.options.mapd.alternative")}</li>
                <li role="listitem">{t("cw.options.mapd.bundled")}</li>
                <li role="listitem">{t("cw.options.mapd.extra_benefits")}</li>
              </ul>
              <Button
                className="ds-u-display--none ds-u-md-display--block ds-c-button ds-c-button--primary-alt mct-u-width--full ds-u-margin-top--2"
                onClick={(): void => {
                  sendTealiumEvent(
                    "Coverage Wizard - Options",
                    "CTA: Medicare Advantage Plan"
                  );

                  chooseCoverage(CoverageType.MAPD);
                }}
              >
                {t("cw.options.mapd")}
              </Button>
            </Card>
          </li>
        </ul>

        <p className="ds-u-md-display--none ds-u-margin-top--4">
          {t("cw.options.choose_option")}
        </p>
        <Button
          className="ds-u-md-display--none ds-c-button ds-c-button--primary-alt mct-u-width--full ds-u-margin-top--2"
          onClick={(): void => chooseCoverage(CoverageType.OriginalMedicare)}
        >
          {t("cw.options.original_medicare")}
        </Button>
        <Button
          className="ds-u-md-display--none ds-c-button ds-c-button--primary-alt mct-u-width--full ds-u-margin-top--2"
          onClick={(): void => chooseCoverage(CoverageType.MAPD)}
        >
          {t("cw.options.mapd")}
        </Button>
      </div>
    </AppPage>
  );
};

export default withRouter(CoverageWizardOptionsPage);
